import React, { useEffect, useMemo, useState, useContext } from 'react';
import 'react-tabs/style/react-tabs.css';
import 'moment/locale/pt-br';
import moment from 'moment';

/* contexts */
import { Context } from '../../../context/UserContext';
import { Tabs, TabList, Tab, TabPanel } from 'react-tabs';

import { Stack, Button, Box, Tooltip, IconButton } from '@mui/material';
import DinnerDiningIcon from '@mui/icons-material/DinnerDining';
import { MaterialReactTable } from 'material-react-table';

import { ThemeProvider } from '@mui/material';
/* tema customizado*/
import tableThemeCustom from '../../form/tableThemeCustom';

/* hooks */
import useFlashMessage from '../../../hooks/useFlashMessage';
import { useNavigateParams } from '../../../hooks/useNavigateParams';

//Import Material React Table Translations
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';

import Input from '../../form/Input';
import InputNumber from '../../form/InputNumber';
import Checkbox from '../../form/Checkbox';
import SelectEmpresa from '../../form/SelectEmpresa';

import formStyles from '../../form/Form.module.css';

/* utils */
import { formatarNumero, formatarNumeroDecimal } from '../../../utils/masks';
import tratar from '../../../utils/retornaTratamentoURL';
import { printPdf } from '../../../utils/funcoes';
import { retornaDataHora, retornaData } from '../../../utils/retornaDataFormatada';

/* api */
import { relatorios } from '../../../api/relatorios';
import * as TabelaPrecoAPI from '../../../api/tabelaPreco';
import * as CotacaoAPI from '../../../api/cotacao';

function Form({
    token,
    dados,
    empresaId,
    empresaIds,
    setDados,
    handleSubmit,

    btnText,
    caminhoVoltar,
    OptionsEmpresa,
    EnumTipo,
}) {
    //grids
    const [itens, setItens] = useState([]);

    /* button enable ou disabled */
    const [isDisabled, setIsDisabled] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const { setFlashMessage } = useFlashMessage();
    const navigate = useNavigateParams();

    //obtem os parametros da empresa

    const tabelaPrecoId = dados.id ? dados.id : null;

    //data and fetching state
    const [isError, setIsError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isRefetching, setIsRefetching] = useState(false);

    const [rowCount, setRowCount] = useState(0);

    const [novoReajuste, setNovoReajuste] = useState({
        percentual: null,
        vigenciaInicio: null,
        vigenciaFim: null,
        empresaId: dados.empresaId,
        tabelaPrecoId: tabelaPrecoId,
        funcao: 'Aplicar',
    });

    const consultaCotacao = async (dia) => {
        if (dia) {
            dia = moment(dia).format('YYYY-MM-DD');
        } else {
            dia = moment().format('YYYY-MM-DD');
        }

        const response = await CotacaoAPI.buscaCotacaoByData(dia);

        if (response.status === 200) {
            setNovoReajuste((prev) => ({
                ...prev,
                cotacaoId: response.data?.id ? response.data?.id : null,
            }));
        }
    };

    //tratar filtros se vier pela navbar
    if (localStorage.path.replace(/["]/g, '') !== window.location.pathname) {
        tratar.LimparFiltros();
        localStorage.setItem('path', JSON.stringify(window.location.pathname));
    }

    //table state
    const [columnFilterFns, setColumnFiltersMode] = useState(
        localStorage.columnFilterFns.length > 2 ? JSON.parse(localStorage.columnFilterFns) : []
    );
    const [columnFilters, setColumnFilters] = useState(
        localStorage.columnFilters.length > 2 ? JSON.parse(localStorage.columnFilters) : []
    );
    const [globalFilter, setGlobalFilter] = useState(() => {
        const storedFilter = localStorage.getItem('globalFilter');

        if (storedFilter && storedFilter !== 'undefined' && storedFilter.length > 2) {
            try {
                return JSON.parse(storedFilter);
            } catch (e) {
                console.warn('Erro ao parsear globalFilter:', e);
                return ''; // valor padrão
            }
        }
        return ''; // valor padrão
    });

    const [sorting, setSorting] = useState(localStorage.sorting.length > 2 ? JSON.parse(localStorage.sorting) : []);
    const [pagination, setPagination] = useState({
        pageIndex: JSON.parse(localStorage.pagination).pageIndex || 0,
        pageSize: JSON.parse(localStorage.pagination).pageSize || 5,
    });

    //abas
    const [abaAtiva, setAbaAtiva] = useState(0);
    const [gridAtiva, setGridAtiva] = useState('tabelaPreco');

    /* identifica a aba atual */
    const handleSelect = (index) => {
        setAbaAtiva(index);

        // Definir qual grid será atualizada com base na aba ativa
        switch (index) {
            case 0:
                setGridAtiva('tabelaPreco');
                break;

            default:
                setGridAtiva('tabelaPreco');
        }
    };

    const [tabEnabled, setTabEnabled] = useState({
        tabelaPreco: true,
    });

    const fetchData = async (grid) => {
        if (!itens.length) {
            setIsLoading(true);
        } else {
            setIsRefetching(true);
        }

        if (dados.id) {
            if (grid === 'tabelaPreco') {
                try {
                    TabelaPrecoAPI.listarProdutos(
                        pagination.pageIndex * pagination.pageSize,
                        pagination.pageSize,
                        JSON.stringify(columnFilters ?? []),
                        JSON.stringify(columnFilterFns ?? []),
                        globalFilter ?? '',
                        JSON.stringify(sorting ?? []),
                        tabelaPrecoId ?? ''
                    ).then((response) => {
                        setItens(response.data.data);
                        setRowCount(response.data.meta.totalRowCount);
                    });
                } catch (error) {
                    setIsError(true);
                    console.error(error);
                    return;
                }
            }
        }

        setIsError(false);
        setIsLoading(false);
        setIsRefetching(false);
    };

    //limpar
    const limparReajuste = () => {
        setNovoReajuste({
            percentual: null,
            vigenciaInicio: null,
            vigenciaFim: null,
            empresaId: dados.empresaId,
            tabelaPrecoId: tabelaPrecoId,
            funcao: 'Aplicar',
        });
        setIsDisabled(true);
    };

    /*Tabela de Preços Produtos*/
    const handleReajuste = async (novoReajuste) => {
        if (novoReajuste.funcao.toLowerCase() === 'aplicar') {
            if (novoReajuste.percentual > 0) {
                //  CreateOrEditProduto(novoReajuste);
            }
        }

        limparReajuste();

        fetchData('tabelaPreco');
    };

    useEffect(() => {
        if (gridAtiva) {
            fetchData(gridAtiva);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        columnFilterFns,
        columnFilters,
        globalFilter,
        pagination.pageIndex,
        pagination.pageSize,
        sorting,
        tabelaPrecoId,
        gridAtiva,
    ]);

    async function handleChange(e) {
        const { name, value, checked, type } = e.target;

        if (name.startsWith('novoReajuste')) {
            if (name === 'novoReajuste.percentual') {
                const valorFormatado = formatarNumeroDecimal(value);

                setNovoReajuste({
                    ...novoReajuste,
                    [name.split('.')[1]]: formatarNumeroDecimal(value),
                });
            } else {
                //set os dados dos checkbox
                setNovoReajuste({
                    ...novoReajuste,
                    empresaId: dados.empresaId,
                    tabelaPrecoId: dados.id,
                    [name.split('.')[1]]: type === 'checkbox' ? checked : value,
                });
            }
        } else {
            setDados({ ...dados, [name]: type === 'checkbox' ? checked : value });
        }
    }
    async function handleOnBlur(e) {}
    async function handleOnFocus(e) {}

    const submit = (e) => {
        e.preventDefault();
        if (isSubmitting) return; // evita clique duplo
        setIsSubmitting(true);
        handleSubmit(dados);
    };

    /* código da grid */
    const getColumnsByTipo = (dados) => {
        if (dados.cardapio) {
            return [
                {
                    id: 'Produtos',
                    header: 'Produtos do cardápio da Tabela de Preços',
                    columns: [
                        {
                            accessorKey: 'prato',
                            header: 'Prato',
                            type: 'boolean',
                            columnFilterModeOptions: ['equals'],
                            filterSelectOptions: [
                                { label: 'Todos', value: '' },
                                { label: 'Sim', value: '1' },
                                { label: 'Não', value: '0' },
                            ],
                            filterVariant: 'select',
                            Cell: ({ row }) => {
                                const value = row.original.prato;
                                return <div style={{ textAlign: 'left' }}>{value ? 'Sim' : 'Não'}</div>;
                            },
                        },
                        {
                            accessorKey: 'Produto.descricao',
                            header: 'Descrição',
                            //you can access a cell in many callback column definition options like this
                            muiTableBodyCellProps: ({ cell }) => ({
                                onClick: () => {},
                            }),
                        },
                        {
                            accessorKey: 'Embalagem.descricao',
                            header: 'Embalagem',
                            //you can access a cell in many callback column definition options like this
                            muiTableBodyCellProps: ({ cell }) => ({
                                onClick: () => {},
                            }),
                        },
                        {
                            accessorKey: 'precoUnitario',
                            header: 'Preço Unitário',
                            muiTableBodyCellProps: {
                                align: 'right',
                            },
                            accessorFn: (row) =>
                                row.precoUnitario === null
                                    ? ''
                                    : 'R$ ' +
                                      parseFloat(row.precoUnitario)?.toLocaleString('pt-BR', {
                                          style: 'decimal',
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                          minimumIntegerDigits: 1,
                                          useGrouping: true,
                                      }),
                        },
                        {
                            accessorKey: 'preco',
                            header: 'Preço Total',
                            muiTableBodyCellProps: {
                                align: 'right',
                            },
                            accessorFn: (row) =>
                                row.preco === null
                                    ? ''
                                    : 'R$ ' +
                                      parseFloat(row.preco)?.toLocaleString('pt-BR', {
                                          style: 'decimal',
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                          minimumIntegerDigits: 1,
                                          useGrouping: true,
                                      }),
                        },
                        {
                            accessorKey: 'vigenciaInicio',
                            id: 'vigenciaInicio',
                            header: 'Início',
                            accessorFn: (row) => new Date(row.vigenciaInicio),
                            Cell: ({ row }) => <span>{moment.utc(row.original.vigenciaInicio).format('DD/MM/YYYY HH:mm')}</span>,
                            filterVariant: 'datetime-local',
                            sortingFn: 'datetime-local',
                            columnFilterModeOptions: [
                                'fuzzy',
                                'equals',
                                'between',
                                'betweenInclusive',
                                'greaterThanOrEqualTo',
                                'lessThanOrEqualTo',
                            ],
                            muiTableBodyCellProps: { align: 'center' },
                            muiTableHeadCellFilterTextFieldProps: {
                                type: 'datetime-local',
                                InputLabelProps: {
                                    shrink: true,
                                },
                                sx: { minWidth: '200px' },
                            },
                        },
                        {
                            accessorKey: 'vigenciaFim',
                            id: 'vigenciaFim',
                            header: 'Término',
                            accessorFn: (row) => new Date(row.vigenciaFim),
                            Cell: ({ row }) => (
                                <span>
                                    {row.original.vigenciaFim
                                        ? moment.utc(row.original.vigenciaFim).format('DD/MM/YYYY HH:mm')
                                        : ''}
                                </span>
                            ),
                            filterVariant: 'datetime-local',
                            sortingFn: 'datetime-local',
                            columnFilterModeOptions: [
                                'fuzzy',
                                'equals',
                                'between',
                                'betweenInclusive',
                                'greaterThanOrEqualTo',
                                'lessThanOrEqualTo',
                            ],
                            muiTableBodyCellProps: { align: 'center' },
                            muiTableHeadCellFilterTextFieldProps: {
                                type: 'datetime-local',
                                InputLabelProps: {
                                    shrink: true,
                                },
                                sx: { minWidth: '200px' },
                            },
                        },
                        {
                            accessorKey: 'versao',
                            header: 'Versão',
                        },
                        {
                            accessorKey: 'Empresa.nomeFantasia',
                            header: 'Empresa',
                        },
                    ],
                },
            ];
        } else {
            return [
                {
                    id: 'Produtos',
                    header: 'Produtos da Tabela de Preços',
                    columns: [
                        {
                            accessorKey: 'Produto.descricao',
                            header: 'Descrição',
                            //you can access a cell in many callback column definition options like this
                            muiTableBodyCellProps: ({ cell }) => ({
                                onClick: () => {},
                            }),
                        },
                        {
                            accessorKey: 'Embalagem.descricao',
                            header: 'Embalagem',
                            //you can access a cell in many callback column definition options like this
                            muiTableBodyCellProps: ({ cell }) => ({
                                onClick: () => {},
                            }),
                        },
                        {
                            accessorKey: 'precoUnitario',
                            header: 'Preço Unitário',
                            muiTableBodyCellProps: {
                                align: 'right',
                            },
                            accessorFn: (row) =>
                                row.precoUnitario === null
                                    ? ''
                                    : 'R$ ' +
                                      parseFloat(row.precoUnitario)?.toLocaleString('pt-BR', {
                                          style: 'decimal',
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                          minimumIntegerDigits: 1,
                                          useGrouping: true,
                                      }),
                        },
                        {
                            accessorKey: 'preco',
                            header: 'Preço Total',
                            muiTableBodyCellProps: {
                                align: 'right',
                            },
                            accessorFn: (row) =>
                                row.preco === null
                                    ? ''
                                    : 'R$ ' +
                                      parseFloat(row.preco)?.toLocaleString('pt-BR', {
                                          style: 'decimal',
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                          minimumIntegerDigits: 1,
                                          useGrouping: true,
                                      }),
                        },
                        {
                            accessorKey: 'vigenciaInicio',
                            id: 'vigenciaInicio',
                            header: 'Início',
                            accessorFn: (row) => new Date(row.vigenciaInicio),
                            Cell: ({ row }) => <span>{moment.utc(row.original.vigenciaInicio).format('DD/MM/YYYY HH:mm')}</span>,
                            filterVariant: 'datetime-local',
                            sortingFn: 'datetime-local',
                            columnFilterModeOptions: [
                                'fuzzy',
                                'equals',
                                'between',
                                'betweenInclusive',
                                'greaterThanOrEqualTo',
                                'lessThanOrEqualTo',
                            ],
                            muiTableBodyCellProps: { align: 'center' },
                            muiTableHeadCellFilterTextFieldProps: {
                                type: 'datetime-local',
                                InputLabelProps: {
                                    shrink: true,
                                },
                                sx: { minWidth: '200px' },
                            },
                        },
                        {
                            accessorKey: 'vigenciaFim',
                            id: 'vigenciaFim',
                            header: 'Término',
                            accessorFn: (row) => new Date(row.vigenciaFim),
                            Cell: ({ row }) => (
                                <span>
                                    {row.original.vigenciaFim
                                        ? moment.utc(row.original.vigenciaFim).format('DD/MM/YYYY HH:mm')
                                        : ''}
                                </span>
                            ),
                            filterVariant: 'datetime-local',
                            sortingFn: 'datetime-local',
                            columnFilterModeOptions: [
                                'fuzzy',
                                'equals',
                                'between',
                                'betweenInclusive',
                                'greaterThanOrEqualTo',
                                'lessThanOrEqualTo',
                            ],
                            muiTableBodyCellProps: { align: 'center' },
                            muiTableHeadCellFilterTextFieldProps: {
                                type: 'datetime-local',
                                InputLabelProps: {
                                    shrink: true,
                                },
                                sx: { minWidth: '200px' },
                            },
                        },
                        {
                            accessorKey: 'versao',
                            header: 'Versão',
                        },
                        {
                            accessorKey: 'Empresa.nomeFantasia',
                            header: 'Empresa',
                        },
                    ],
                },
            ];
        }
    };
    const columns = useMemo(() => {
        return getColumnsByTipo(dados, gridAtiva);
    }, [dados, gridAtiva]);
    /* modo tema */
    const theme = tableThemeCustom();
    return (
        <div>
            <Tabs selectedIndex={abaAtiva} onSelect={handleSelect}>
                <form onSubmit={submit}>
                    <div className={formStyles.stiloPadrao}>
                        <h1>Reajuste de Preços</h1>
                        <TabList>
                            <Tab disabled={!tabEnabled.tabelaPreco} title={'Tabela de Preços'}>
                                Parâmetros
                            </Tab>
                        </TabList>
                        <TabPanel>
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    marginTop: '1rem',
                                    flexWrap: 'wrap',
                                }}
                            >
                                <SelectEmpresa
                                    text="Selecione a Empresa"
                                    name="empresaId"
                                    options={OptionsEmpresa}
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={dados.empresaId || ''}
                                    required
                                    notOptNull={true}
                                />
                                <Input
                                    text="Referência"
                                    type="text"
                                    name="referencia"
                                    placeholder="nome simplificado"
                                    inputWidth="100px"
                                    title="Digite a referência da tabela de preço, nome simplificado"
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={dados.referencia || ''}
                                    required
                                />
                                <Input
                                    text="Descrição"
                                    type="text"
                                    name="descricao"
                                    placeholder="Nome da Tabela"
                                    title="Digite o nome da tabela de preços"
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    inputWidth="200px"
                                    value={dados.descricao || ''}
                                    required
                                />
                                <Checkbox
                                    title="Tabela para movimentos de restaurante"
                                    text="Cardápio"
                                    name="cardapio"
                                    handleOnChange={handleChange}
                                    value={dados.cardapio}
                                    checked={!!dados.cardapio}
                                />
                                <InputNumber
                                    text="Percentual"
                                    type="text"
                                    name="novoReajuste.percentual"
                                    placeholder="Valor %"
                                    inputWidth="100px"
                                    title="digite o percentual de aumento que será aplicado aos itens da tabela de preços"
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={novoReajuste.percentual ? formatarNumero(novoReajuste.percentual) : ''}
                                />
                                <Input
                                    text="Data Início"
                                    type="datetime-local"
                                    name="novoReajuste.vigenciaInicio"
                                    placeholder="última atualização"
                                    title="Data inicial do preço dos produtos na tabela"
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={novoReajuste.vigenciaInicio && retornaDataHora(novoReajuste.vigenciaInicio)}
                                    inputWidth={'150px'}
                                />
                                <Input
                                    text="Data Término"
                                    type="datetime-local"
                                    name="novoReajuste.vigenciaFim"
                                    placeholder=""
                                    title="Data final para o preço dos produtos na tabela"
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={novoReajuste.vigenciaFim && retornaDataHora(novoReajuste.vigenciaFim)}
                                    inputWidth={'150px'}
                                />
                                <Button
                                    variant="contained"
                                    color="inherit"
                                    onClick={() => {
                                        limparReajuste();
                                    }}
                                    style={{ marginLeft: '10px' }}
                                >
                                    Limpar
                                </Button>
                                <Button
                                    variant="contained"
                                    color={novoReajuste.funcao === 'deletar' ? 'error' : 'info'}
                                    onClick={() => handleReajuste(novoReajuste)}
                                    disabled={isDisabled}
                                    style={{ marginLeft: '5px' }}
                                >
                                    {novoReajuste.funcao}
                                </Button>
                            </div>

                            <ThemeProvider theme={theme}>
                                <MaterialReactTable
                                    displayColumnDefOptions={{
                                        'mrt-row-actions': {
                                            muiTableHeadCellProps: {
                                                align: 'center',
                                            },
                                            size: 100,
                                        },
                                        'mrt-row-numbers': {
                                            enableColumnOrdering: true, //turn on some features that are usually off
                                            enableResizing: true,
                                            muiTableHeadCellProps: {
                                                sx: {
                                                    fontSize: '1.2rem',
                                                },
                                            },
                                        },
                                        'mrt-row-select': {
                                            enableColumnActions: true,
                                            enableHiding: true,
                                            size: 50,
                                        },
                                    }}
                                    enableColumnFilterModes
                                    enableGlobalFilterModes
                                    //enableColumnResizing
                                    enableColumnOrdering
                                    renderTopToolbarCustomActions={() => {
                                        const handleImprimir = async (obj) => {
                                            const response = await relatorios('tabelaPreco', 'tabelaPrecos', obj);
                                            //gera o pdf
                                            printPdf(response.data);
                                        };

                                        return (
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    gap: '8px',
                                                }}
                                            >
                                                <Tooltip arrow placement="top-end" title={`Relação de pratos`}>
                                                    <div>
                                                        <span>
                                                            <Button
                                                                color="info"
                                                                variant="contained"
                                                                disabled={
                                                                    JSON.parse(localStorage.getItem('imprimir')) !== true ||
                                                                    dados.cardapio !== true
                                                                }
                                                                onClick={() => handleImprimir({ obj: dados, prato: true })}
                                                            >
                                                                <DinnerDiningIcon />
                                                            </Button>
                                                        </span>
                                                    </div>
                                                </Tooltip>
                                            </div>
                                        );
                                    }}
                                    columns={columns}
                                    data={itens}
                                    enableRowSelection
                                    getRowId={(row) => row.uuid}
                                    manualFiltering
                                    manualPagination
                                    manualSorting
                                    muiToolbarAlertBannerProps={
                                        isError
                                            ? {
                                                  color: 'error',
                                                  children: 'Error loading data',
                                              }
                                            : undefined
                                    }
                                    onColumnFiltersChange={setColumnFilters}
                                    onColumnFilterFnsChange={setColumnFiltersMode}
                                    onGlobalFilterChange={setGlobalFilter}
                                    onPaginationChange={setPagination}
                                    onSortingChange={setSorting}
                                    rowCount={rowCount}
                                    initialState={{
                                        showColumnFilters: true,
                                        density: 'compact',
                                        //columnPinning: { left: ["mrt-row-select"] },
                                    }}
                                    state={{
                                        columnFilterFns,
                                        columnFilters,
                                        globalFilter,
                                        isLoading,
                                        pagination,
                                        showAlertBanner: isError,
                                        showProgressBars: isRefetching,
                                        sorting,
                                    }}
                                    //positionToolbarDropZone={"top"}
                                    positionExpandColumn={'first'}
                                    positionActionsColumn={'first'}
                                    positionToolbarAlertBanner="bottom"
                                    localization={MRT_Localization_PT_BR}
                                />
                            </ThemeProvider>
                        </TabPanel>
                    </div>
                    <div>
                        <Stack direction="row" spacing={1}>
                            <Button variant="contained" color="secondary" onClick={() => navigate(caminhoVoltar)}>
                                Voltar
                            </Button>
                            <Button type="submit" variant="contained" color="success" disabled={isSubmitting || true}>
                                {btnText}
                            </Button>
                        </Stack>
                    </div>
                </form>
            </Tabs>
        </div>
    );
}
export default Form;
